import { render, staticRenderFns } from "./IconSpotify.vue?vue&type=template&id=3465fc6a&"
import script from "./IconSpotify.vue?vue&type=script&lang=js&"
export * from "./IconSpotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports